// extracted by mini-css-extract-plugin
export default {"content":"CuratedExperiencesList_content__AjN6w"};